import { createAction } from "redux-act";

export const CanvasNewAction = createAction("Canvas New");
export const CanvasNewRequestAction = createAction("Canvas New - Request");
export const CanvasNewSuccessAction = createAction("Canvas New - Success");
export const CanvasNewFailedAction = createAction("Canvas New - Failed");
